export default __webpack_public_path__ + "static/media/DDU_Transcript.bae7e0e9.pdf";